import { useParams } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client/core/networkStatus';

import { FullScreenProgress, Typography } from '@occc-app/design-system';

import { useGetPointChangeById } from '@occc-app/dataAccessLayer/pointChange/queries';
import { MemberPointChangeDetailsPage } from './MemberPointChangeDetailsPage';
import { errorMessage, noDataMessage } from './copies';

export const MemberPointChangeDetailsPageContainer = () => {
  const { id = '' } = useParams<{ id: string }>();

  const { data: pointChange, error, loading, networkStatus } = useGetPointChangeById(id);

  if (loading && networkStatus !== NetworkStatus.refetch) return <FullScreenProgress />;

  if (error) {
    return (
      <Typography color='error' data-testid='something-went-wrong-msg'>
        {errorMessage}
      </Typography>
    );
  }

  if (!pointChange) {
    return (
      <Typography color='error' data-testid='no-data-msg'>
        {noDataMessage}
      </Typography>
    );
  }

  return <MemberPointChangeDetailsPage pointChange={pointChange} />;
};
